(() => {
  function initSapphireTabs(root) {
    const tabs = root.querySelectorAll('[data-sapphire-tab]');
    const panels = root.querySelectorAll('[data-sapphire-panel]');
    if (!tabs.length || !panels.length) return;

    const activate = (id) => {
      tabs.forEach((tab) => {
        const active = tab.getAttribute('data-sapphire-tab') === id;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach((panel) => {
        const active = panel.getAttribute('data-sapphire-panel') === id;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        activate(tab.getAttribute('data-sapphire-tab'));
      });
    });

    const initial =
      root.querySelector('[data-sapphire-tab].is-active')?.getAttribute('data-sapphire-tab') ||
      tabs[0].getAttribute('data-sapphire-tab');
    activate(initial);
  }

  function initSapphireHeaderNav() {
    document.querySelectorAll('[data-sapphire-open-tab]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const tabId = link.getAttribute('data-sapphire-open-tab');
        const drawer = document.querySelector('header-drawer');
        const details = drawer?.querySelector('details');
        const summary = details?.querySelector('summary');
        if (!drawer || !details || !summary || !tabId) return;

        event.preventDefault();

        const activateTab = () => {
          const tab = document.querySelector(`[data-sapphire-tab="${tabId}"]`);
          tab?.click();
        };

        if (!details.hasAttribute('open')) {
          summary.click();
          setTimeout(activateTab, 50);
        } else {
          activateTab();
        }
      });
    });
  }

  function initSapphireScrollState() {
    const wrapper = document.querySelector('.header-wrapper--sapphire-overlay');
    if (!wrapper) return;

    const onScroll = () => {
      const scrolled = window.scrollY > 24;
      wrapper.classList.toggle('sapphire-scrolled', scrolled);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function syncMenuOpenClass() {
    const section = document.querySelector('.section-header');
    const wrapper = document.querySelector('.header-wrapper--sapphire-overlay');
    if (!section || !wrapper) return;

    const sync = () => {
      wrapper.classList.toggle('menu-open', section.classList.contains('menu-open'));
    };

    sync();
    new MutationObserver(sync).observe(section, { attributes: true, attributeFilter: ['class'] });
  }

  function closeSapphireDrawer() {
    const details = document.querySelector('header-drawer details[open]');
    const summary = details?.querySelector('summary');
    if (!summary) return;
    summary.click();
  }

  function initSapphireOverlay() {
    if (!document.querySelector('.header--sapphire')) return;

    document.querySelectorAll('[data-sapphire-backdrop]').forEach((backdrop) => {
      backdrop.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        closeSapphireDrawer();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-sapphire-drawer]').forEach(initSapphireTabs);
    initSapphireHeaderNav();
    initSapphireScrollState();
    syncMenuOpenClass();
    initSapphireOverlay();
  });
})();
